import { combineReducers } from 'redux';

import { listReducer } from './list';

export const issuersReducer = combineReducers({
  list: listReducer,
});

export type StoreIssuers = ReturnType<typeof issuersReducer>;
